/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Input, Loading } from '@nike/frame-component-library';
import {
  Close, Delete,
} from '@nike/nike-design-system-icons';
import countries from 'i18n-iso-countries';
import Papa from 'papaparse';
import React, {
  useState, useEffect, createRef,
} from 'react';
import { useSelector } from 'react-redux';
import ReactSelect from 'react-select';

import {
  trackScsBulkEditStarted,
  trackScsBulkEditScopeSelected,
  trackScsBulkEditFilterApplied,
  trackScsBulkEditExecuted,
  trackScsBulkEditSuccess,
  trackScsBulkEditError,
} from '../../../utils/analytics';
import { loadState } from '../../../utils/local-storage';
import { getStores } from '../../../utils/service-calls/reusable';
import { scsDefinitionGet, scsBulkedit, scsSchedulePost } from '../../../utils/service-calls/scs';
import { Geo, toGeo } from '../../../utils/static/scs-geo-iso-map';
import { isUserAllowed } from '../../../utils/tab-permissions';
import Modal from '../../ccm/Modal';
import {
  ButtonBlack,
  ButtonRed,
  ButtonWhite,
  TableRowClick,
} from '../../reusable';
import ScheduleForLater, { ScheduleBanner } from '../ScheduleForLater';

import FilterOverlay from './filters';
import Selected from './selected';

import './bulkedit.css';

const scsKeyGroups = ['SCS.ALL', 'SCS.ASSIST', 'SCS.LINK', 'SCS.NPOS', 'SCS.OTHER', 'SCS.POS', 'SCS.PROMOTE', 'SCS.RL', 'SCS.RISE', 'SCS.SFS', 'SCS.SIM', 'SCS.SCO', 'SCS.TRACK'];

const securityGroupMap = new Map([
  ['POS Settings', 'SCS.POS'],
  ['AIC Settings', 'SCS.ASSIST'],
  ['Assist Settings', 'SCS.ASSIST'],
  ['Nike+ Link Settings', 'SCS.LINK'],
  ['NSP Settings', 'SCS.ASSIST'],
  ['RISE Settings', 'SCS.RISE'],
  ['SCORE Settings', 'SCS.SFS'],
  ['SIM Settings', 'SCS.SIM'],
  ['Self Checkout Settings', 'SCS.SCO'],
  ['NPOS Settings', 'SCS.NPOS'],
  ['Retail Launchpad', 'SCS.RL'],
  ['Promote App Settings', 'SCS.PROMOTE'],
  ['Other Settings', 'SCS.OTHER'],
  ['Track Settings', 'SCS.TRACK'],
]);

const fields = [
  'id',
  'storeNumber',
  'name',
  'company',
  'facilityType',
  'businessConcept',
  'storeConcept',
  'address.country',
  'address.city',
  'address.state',
  'region',
  'offerings.name',
  'brand',
  'storeServices.serviceGroup',
  'storeServices.serviceSubGroup',
  'storeStatus',
];
const columns = [
  {
    accessor: (data) => data.key,
    Header: 'Config Key',
    id: 'Config Key',
  },
  {
    accessor: (data) => data.scopeType,
    Header: 'Scope Type',
    id: 'Scope Type',
  },
  {
    accessor: (data) => data.scope,
    Header: 'Scope',
    id: 'Scope',
  }
];

const csvPreviewColumns = [
  { accessor: (row) => row.storeNumber, Header: 'Store #', id: 'csv-store-number' },
  { accessor: (row) => row.storeName, Header: 'Store Name', id: 'csv-store-name' },
  { accessor: (row) => row.country, Header: 'Country', id: 'csv-country' },
  { accessor: (row) => row.key, Header: 'Key', id: 'csv-key' },
  { accessor: (row) => row.value, Header: 'Value', id: 'csv-value' },
];

const config = require('../../../config')();

const globalCommonSelectorOption = {
  data: [
    {
      id: 'GLOBAL',
      label: 'Global',
      scope: 'GLOBAL',
    },
  ],
  scopeType: 'GLOBAL',
};

// let selectedCommonSelectorOption = null;

const SCSBulkEdit = () => {
  const { accessToken } = loadState('auth');
  const [stores, setStores] = useState([]);
  const [filteredStores, setFilteredStores] = useState([]);
  const [selectionSearch, setSelectionSearch] = useState('');
  const [selectedSearch, setSelectedSearch] = useState('');
  const [isFilterOverlayVisible, setIsFilterOverlayVisible] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [selectedScsRegionOption, setSelectedScsRegionOption] = useState(null);
  const [selectedScsScopeOption, setSelectedScsScopeOption] = useState(null);
  const [selectedScsRegionScopeOption, setSelectedScsRegionScopeOption] = useState(null);
  const [selectedKey, setSelectedKey] = useState(null);
  const [selectedCommonSelectorOption, setSelectedCommonSelectorOption] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [filteredKeyDefinitions, setFilteredKeyDefinitions] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [allKeyDefinitions, setAllKeyDefinitions] = useState([]);
  const [failedConfigs, setFailedConfigs] = useState([]);
  const [successfulConfigs, setSuccessfulConfigs] = useState([]);
  const [isBulkUpdateSuccessModalOpen, setIsBulkUpdateSuccessModalOpen] = useState(false);
  const [isBulkUpdateFailureModalOpen, setIsBulkUpdateFailureModalOpen] = useState(false);
  const [isBulkUpdateComplete, setIsBulkUpdateComplete] = useState(true);
  const [isRegionChangeModalOpen, setIsRegionChangeModalOpen] = useState(false);
  const [isScopeChangeModalOpen, setIsScopeChangeModalOpen] = useState(false);
  const [isUpdateConfirmModalOpen, setIsUpdateConfirmModalOpen] = useState(false);
  const [csvParsedData, setCsvParsedData] = useState([]);
  const [csvErrors, setCsvErrors] = useState([]);
  const [csvDuplicateWarnings, setCsvDuplicateWarnings] = useState([]);
  const [isCsvPreviewModalOpen, setIsCsvPreviewModalOpen] = useState(false);
  const [isCsvUploading, setIsCsvUploading] = useState(false);
  const [csvFileName, setCsvFileName] = useState('');
  const [csvFileComponentKey, setCsvFileComponentKey] = useState(Date.now());
  const [scheduleForLater, setScheduleForLater] = useState(false);
  const [scheduledDate, setScheduledDate] = useState('');
  const [scheduledTime, setScheduledTime] = useState('');
  const [isScheduleComplete, setIsScheduleComplete] = useState(true);
  const [wasScheduled, setWasScheduled] = useState(false);
  const userInfo = useSelector((state) => state.authorizationReducer.auth);
  const [filteringCondition, setFilteringCondition] = useState({
    country: { label: 'All Countries', value: '' },
    facilityType: { label: 'All Facility Types', value: '' },
    region: { label: 'Select a Region', value: '' },
    regionSelected: false,
    search: '',
    state: { label: 'All States', value: '' },
    storeStatus: { label: 'All Store Statuses', value: '' },
});

const updateFilterRef = createRef();

const getLabel = (key) => {
  switch (key) {
    case 'country':
      return 'All Countries';
    case 'facilityType':
      return 'All Facility Types';
    case 'region':
      return 'All Regions';
    case 'state':
      return 'All States';
    case 'storeStatus':
      return 'All Store Statuses';
    default:
      return '';
  }
};

// check if all the values in filteringCondition are empty
const isFilterEmpty = () => {
  const keys = Object.keys(filteringCondition);
  for (let i = 0; i < keys.length; i += 1) {
    // check if the value is not undefined and not empty
    if (filteringCondition[keys[i]].value !== '' && filteringCondition[keys[i]].value !== undefined) {
      return false;
    }
  }
  return true;
};

const cancelFilter = (key) => {
  const newFilteringCondition = { ...filteringCondition, [key]: { label: getLabel(key), value: '' } };
  setFilteringCondition(newFilteringCondition);
  updateFilterRef.current(key, { label: getLabel(key), value: '' }); // Example call to updateFilter
};

  const updateRegion = (regionOption) => {
    setSelectedScsRegionScopeOption(regionOption);
    if (selectedScsRegionOption && selectedScsRegionOption.value !== regionOption.value && selectedCommonSelectorOption) {
      setIsRegionChangeModalOpen(true);
    } else {
      setSelectedScsRegionOption(regionOption);
    }
  };

  const updateScsScope = (scopeOption) => {
    setSelectedScsRegionScopeOption(scopeOption);
    if (selectedScsScopeOption && selectedScsScopeOption.value !== scopeOption.value && selectedCommonSelectorOption) {
      setIsScopeChangeModalOpen(true);
    } else {
      setSelectedScsScopeOption(scopeOption);
      // Track scope selection
      trackScsBulkEditScopeSelected({
        region: selectedScsRegionOption?.value,
        scopeType: scopeOption.value,
      });
    }
  };

  const changeRegion = () => {
    setIsRegionChangeModalOpen(false);
    setSelectedScsRegionOption(selectedScsRegionScopeOption);
    setSelectedKey(null);
    setSelectedCommonSelectorOption(null);
  };

  const changeScope = () => {
    setIsScopeChangeModalOpen(false);
    setSelectedScsScopeOption(selectedScsRegionScopeOption);
    setSelectedKey(null);
    setSelectedCommonSelectorOption(null);
  };

  const applyFilter = () => {
    setIsFilterOverlayVisible(true);
 };

 const clearAllFilters = () => {
   setIsFilterApplied(false);
};

 const filterApplied = () => {
   setIsFilterApplied(true);
   // Track filter applied
   trackScsBulkEditFilterApplied({
     filterType: 'store',
     filterValue: JSON.stringify(filteringCondition),
     resultsCount: filteredStores.length,
   });
};

 const closeFilterOverlay = () => {
   setIsFilterOverlayVisible(false);
};

const updateStores = (filteredStoresFromFilter) => {
  if (selectedScsScopeOption && selectedScsScopeOption.value === 'STORE') {
  setFilteredStores(filteredStoresFromFilter);
  }
};

const handleFilteringConditionChange = (newFilteringCondition) => {
  setFilteringCondition(newFilteringCondition);
};

  const checkIfAlreadyExists = (commonSelectorOption) => {
    let exists = false;
    if (selectedCommonSelectorOption && selectedCommonSelectorOption.data) {
      selectedCommonSelectorOption.data.forEach((option) => {
        if (option.id === commonSelectorOption.id) {
          exists = true;
        }
      });
    }
    return exists;
  };

  const updateCommonSelector = (commonSelectorOption) => {
    setSelectedKey(commonSelectorOption.id);
    if (!selectedScsScopeOption) return;

    const scopeType = selectedScsScopeOption.value;
    const commonSelector = selectedCommonSelectorOption || { data: [], scopeType };

    if (checkIfAlreadyExists(commonSelectorOption)) return;

    let newOption = {
      id: commonSelectorOption.id,
      label: scopeType === 'STORE' ? `${commonSelectorOption.storeNumber} - ${commonSelectorOption.name}` : commonSelectorOption.name,
      scope: commonSelectorOption.id,
    };

    if (scopeType === 'STORE') {
      newOption = {
        ...newOption,
        brand: commonSelectorOption.brand,
        country: commonSelectorOption.address.country,
        geo: toGeo(commonSelectorOption),
        scope: `${commonSelectorOption.address.country}-${commonSelectorOption.storeNumber}`,
      };
    } else if (scopeType === 'COUNTRY') {
      newOption = {
        ...newOption,
        brand: commonSelectorOption.brand,
        country: commonSelectorOption.country,
        geo: commonSelectorOption.geo,
        scope: commonSelectorOption.country,
      };
    } else if (scopeType === 'GLOBAL') {
      newOption = {
        ...newOption,
        id: 'GLOBAL',
        label: 'Global',
        scope: 'GLOBAL',
      };
    }

    commonSelector.data.push(newOption);
    setSelectedCommonSelectorOption(commonSelector);
  };

  const updateSelectedCommonSelectorOption = (commonSelectorOption) => {
    // check if commonSelectorOption.data is empty, then set it to null
    if (commonSelectorOption.data.length === 0) {
      setSelectedCommonSelectorOption(null);
    } else {
    setSelectedCommonSelectorOption(commonSelectorOption);
    }
  };

  const filterScsKeyOptionsForRegion = filteredKeyDefinitions.map((key) => ({
    label: key.key,
    type: key.type,
    value: key.id,
  }));

  const updateScsKey = (keyOption) => {
    // get the existing keys from SelectedKeys
    // check if the keyOption is already present in the selectedKeys
    // if not, add it to the selectedKeys
    const keyExists = selectedKeys.some((key) => key.label === keyOption.label);
    if (!keyExists) {
      setSelectedKeys((prevSelectedKeys) => [...prevSelectedKeys, { ...keyOption, type: keyOption.type, value: '' }]);
    }
  };

  const handleInputChange = (value) => {
    setInputValue(value);
    if (value.length >= 3) {
      const filteredDefinitions = allKeyDefinitions.filter((key) => key.key.toLowerCase().includes(value.toLowerCase()));
      setFilteredKeyDefinitions(filteredDefinitions);
    } else {
      setFilteredKeyDefinitions([]);
    }
  };

  const handleValueChange = (index, newValue) => {
    // set the value of the key in the selectedKeys
    const updatedKeys = selectedKeys.map((key, i) => (i === index ? { ...key, value: newValue } : key));
    setSelectedKeys(updatedKeys);
  };

  const generateJustification = (keys) => keys
    .map((item) => `${userInfo?.email || 'User'} has updated the ${item.key || item.label} to ${item.value}`)
    .join('; ');

  const handleMenuOpen = () => {
    setInputValue('');
  };

  const resetScheduleState = () => {
    setScheduleForLater(false);
    setScheduledDate('');
    setScheduledTime('');
  };

  const scheduleBulkConfigs = async () => {
    setIsScheduleComplete(false);
    const { scopeType } = selectedCommonSelectorOption || globalCommonSelectorOption;
    const scopeInfo = selectedCommonSelectorOption?.data || globalCommonSelectorOption.data;

    const scheduledStartTime = scheduledDate && scheduledTime
      ? `${scheduledDate}T${scheduledTime}:00`
      : '';

    const schedules = [];
    selectedKeys.forEach((key) => {
      scopeInfo.forEach((scope) => {
        schedules.push({
          hierarchy: selectedScsScopeOption?.value === 'GLOBAL'
            ? null
            : {
                brand: scope.brand || 'NIKE',
                country: scope.country || '',
                geo: scope.geo || '',
              },
          key: key.label,
          scope: scope.scope,
          scopeType,
          value: key.value,
        });
      });
    });

    const body = {
      changeRequest: {
        createdBy: userInfo?.email || '',
        justification: generateJustification(selectedKeys),
      },
      scheduledStartTime,
      schedules,
    };

    trackScsBulkEditExecuted({
      hasJustification: true,
      keysCount: selectedKeys.length,
      region: selectedScsRegionOption?.value || 'use1',
      scopesCount: scopeInfo.length,
      scopeType,
      userEmail: userInfo?.email,
    });

    try {
      const scsRegion = selectedScsRegionOption?.value || 'use1';
      await scsSchedulePost(accessToken, body, scsRegion);

      trackScsBulkEditSuccess({
        failedCount: 0,
        successCount: schedules.length,
        totalCount: schedules.length,
        userEmail: userInfo?.email,
      });

      setSuccessfulConfigs(schedules.map((s) => ({ key: s.key, scope: s.scope, scopeType: s.scopeType })));
      setFailedConfigs([]);
      setIsBulkUpdateSuccessModalOpen(true);
    } catch (error) {
      trackScsBulkEditError({
        errorMessage: error.message || 'Unknown error',
        keysCount: selectedKeys.length,
        scopesCount: scopeInfo.length,
        userEmail: userInfo?.email,
      });
      setIsBulkUpdateFailureModalOpen(true);
    } finally {
      setIsScheduleComplete(true);
    }
  };

  const removeKey = (index) => {
    const updatedKeys = [...selectedKeys];
    updatedKeys.splice(index, 1);
    setSelectedKeys(updatedKeys);
  };

  const updateBulkConfigs = async () => {
    setIsBulkUpdateComplete(false);
    const { scopeType } = selectedCommonSelectorOption || globalCommonSelectorOption;
    const scopeInfo = selectedCommonSelectorOption?.data || globalCommonSelectorOption.data;

    const data = selectedKeys.map((key) => ({
      key: key.label,
      scopeInfo: scopeInfo.map((scope) => ({
        hierarchy: selectedScsScopeOption?.value === 'GLOBAL'
          ? null
          : {
              brand: scope.brand || '',
              country: scope.country || '',
              geo: scope.geo || '',
            },
        scope: scope.scope,
      })),
      scopeType,
      value: key.value,
    }));

    const body = {
      changeRequest: {
        justification: generateJustification(selectedKeys),
        requestedBy: userInfo?.email || '',
      },
      data,
    };

    // Track bulk edit execution
    trackScsBulkEditExecuted({
      hasJustification: true,
      keysCount: selectedKeys.length,
      region: selectedScsRegionOption?.value || 'use1',
      scopesCount: scopeInfo.length,
      scopeType,
      userEmail: userInfo?.email,
    });

    try {
        const token = accessToken; // Adjust as needed to get the token
        const scsRegion = selectedScsRegionOption?.value || 'use1';
        const response = await scsBulkedit(token, body, scsRegion);
        setFailedConfigs(response.body.failure);
        setSuccessfulConfigs(response.body.success);

        // Track bulk edit success/partial success
        trackScsBulkEditSuccess({
          failedCount: response.body.failure?.length || 0,
          successCount: response.body.success?.length || 0,
          totalCount: (response.body.success?.length || 0) + (response.body.failure?.length || 0),
          userEmail: userInfo?.email,
        });

        setIsBulkUpdateSuccessModalOpen(true);
      } catch (error) {
        // Track bulk edit error
        trackScsBulkEditError({
          errorMessage: error.message || 'Unknown error',
          keysCount: selectedKeys.length,
          scopesCount: scopeInfo.length,
          userEmail: userInfo?.email,
        });
        setIsBulkUpdateFailureModalOpen(true);
      } finally {
        setIsBulkUpdateComplete(true);
      }
  };

  const getSelectionList = () => {
    if (selectedScsScopeOption?.value === 'STORE') {
      const selectionStores = isFilterApplied ? filteredStores : stores;
      // filter the stores based on the search input
      return selectionStores.filter((store) => {
        const storeName = store.name.toLowerCase();
        const storeNumber = store.storeNumber.toLowerCase();
        return storeName.includes(selectionSearch.toLowerCase()) || storeNumber.includes(selectionSearch.toLowerCase());
      });
    } else if (selectedScsScopeOption?.value === 'COUNTRY') {
        const countryCodeMap = stores.reduce((acc, store) => {
          acc[store.address.country] = {
            brand: 'NIKE',
            country: store.address.country,
            geo: toGeo(store),
            id: store.address.country,
            name: store.address.country === 'TUR' ? 'Türkiye' : countries.getName(store.address.country, 'en')
          };
          return acc;
        }, {});

        const countryMap = Object.keys(countryCodeMap).map((key) => countryCodeMap[key]);
        return countryMap.filter((country) => {
          const countryName = country.name.toLowerCase();
          return countryName.includes(selectionSearch.toLowerCase());
        });
    } else if (selectedScsScopeOption?.value === 'GEO') {
      return [
        { id: Geo.ASIA, name: 'Asia' },
        { id: Geo.EM, name: 'Emerging Markets' },
        { id: Geo.EUROPE, name: 'Europe' },
        { id: Geo.ILS, name: 'ILS' },
        { id: Geo.JPN, name: 'Japan' },
        { id: Geo.NA, name: 'North America' },
        { id: Geo.RUB, name: 'Russia' },
        { id: Geo.SA, name: 'South America' }
      ];
    } else if (selectedScsScopeOption?.value === 'GLOBAL') {
      return [{ id: 'GLOBAL', name: 'Global' }];
    }
    return [];
  };

  const handleModalClose = () => {
    setIsBulkUpdateSuccessModalOpen(false);
    setIsBulkUpdateFailureModalOpen(false);
    setSelectedKeys([]);
    setFailedConfigs([]);
    setSelectedCommonSelectorOption(null);
    setIsEditMode(false);
    setSelectedSearch('');
    setSelectionSearch('');
    setWasScheduled(false);
    resetScheduleState();
  };

  const resetCsvState = () => {
    setCsvParsedData([]);
    setCsvErrors([]);
    setCsvDuplicateWarnings([]);
    setCsvFileName('');
    setCsvFileComponentKey(Date.now());
  };

  const MAX_CSV_ROWS = 300;
  const MAX_CSV_FILE_SIZE = 5 * 1024 * 1024;

  const processCsvText = (text) => {
    const errors = [];
    const validRows = [];
    const duplicateWarnings = [];

    const parsed = Papa.parse(text, { header: true, skipEmptyLines: true });

    if (parsed.errors.length > 0) {
      const parseErrors = parsed.errors.map((e) => `Row ${(e.row ?? 0) + 2}: ${e.message}`);
      setCsvErrors(parseErrors);
      setCsvParsedData([]);
      setCsvDuplicateWarnings([]);
      setIsCsvPreviewModalOpen(true);
      return;
    }

    const actualHeaders = parsed.meta.fields || [];
    const requiredHeaders = ['storeNumber', 'country', 'key', 'value'];
    const missingHeaders = requiredHeaders.filter((h) => !actualHeaders.includes(h));

    if (missingHeaders.length > 0) {
      setCsvErrors([`Missing required CSV columns: ${missingHeaders.join(', ')}. Expected: storeNumber, country, key, value`]);
      setCsvParsedData([]);
      setCsvDuplicateWarnings([]);
      setIsCsvPreviewModalOpen(true);
      return;
    }

    if (parsed.data.length === 0) {
      setCsvErrors(['CSV file has no data rows']);
      setCsvParsedData([]);
      setCsvDuplicateWarnings([]);
      setIsCsvPreviewModalOpen(true);
      return;
    }

    if (parsed.data.length > MAX_CSV_ROWS) {
      setCsvErrors([`CSV file has ${parsed.data.length} data rows, which exceeds the maximum of ${MAX_CSV_ROWS}`]);
      setCsvParsedData([]);
      setCsvDuplicateWarnings([]);
      setIsCsvPreviewModalOpen(true);
      return;
    }

    const storesByCountryNumber = {};
    stores.forEach((s) => {
      const lookupKey = `${s.address.country}-${s.storeNumber}`;
      if (!storesByCountryNumber[lookupKey]) {
        storesByCountryNumber[lookupKey] = [];
      }
      storesByCountryNumber[lookupKey].push(s);
    });

    const parsedRows = parsed.data.map((row, index) => ({
      country: (row.country || '').trim(),
      key: (row.key || '').trim(),
      rowNum: index + 2,
      storeNumber: (row.storeNumber || '').trim(),
      value: (row.value ?? '').trim(),
    })).filter((row) => row.storeNumber || row.country || row.key || row.value);

    const storeKeyValueMap = {};
    parsedRows.forEach((row) => {
      const compositeKey = JSON.stringify([row.storeNumber, row.country, row.key]);
      if (!storeKeyValueMap[compositeKey]) {
        storeKeyValueMap[compositeKey] = { rows: [], values: new Set() };
      }
      storeKeyValueMap[compositeKey].values.add(row.value);
      storeKeyValueMap[compositeKey].rows.push(row.rowNum);
    });

    const conflictingKeys = new Set();
    Object.entries(storeKeyValueMap).forEach(([compositeKey, { values, rows }]) => {
      const [storeNumber, country, key] = JSON.parse(compositeKey);
      if (values.size > 1) {
        conflictingKeys.add(compositeKey);
        duplicateWarnings.push(
          `Rows ${rows.join(', ')}: Store ${storeNumber} (${country}) + Key "${key}" has conflicting values (${[...values].join(', ')})`
        );
      } else if (rows.length > 1) {
        duplicateWarnings.push(
          `Rows ${rows.join(', ')}: Store ${storeNumber} (${country}) + Key "${key}" has redundant duplicate entries`
        );
      }
    });

    const duplicateStoreWarned = new Set();
    const processedEntries = new Set();

    parsedRows.forEach((row) => {
      const {
        rowNum, storeNumber, country, key, value,
      } = row;
      const compositeKey = JSON.stringify([storeNumber, country, key]);

      if (conflictingKeys.has(compositeKey)) return;
      if (processedEntries.has(compositeKey)) return;
      processedEntries.add(compositeKey);

      if (!storeNumber) {
        errors.push(`Row ${rowNum}: Missing storeNumber`);
        return;
      }
      if (!country) {
        errors.push(`Row ${rowNum}: Missing country`);
        return;
      }
      if (!key) {
        errors.push(`Row ${rowNum}: Missing key`);
        return;
      }
      const trimmedValue = typeof value === 'string' ? value.trim() : value;
      if (trimmedValue === '' || trimmedValue === 'null' || trimmedValue === 'undefined') {
        errors.push(`Row ${rowNum}: Missing or empty value`);
        return;
      }

      if (allKeyDefinitions.length > 0 && !allKeyDefinitions.some((def) => def.key === key)) {
        errors.push(`Row ${rowNum}: Key "${key}" is not a valid configuration key`);
        return;
      }

      const lookupKey = `${country}-${storeNumber}`;
      const matchingStores = storesByCountryNumber[lookupKey];

      if (!matchingStores || matchingStores.length === 0) {
        errors.push(`Row ${rowNum}: Store "${storeNumber}" in country "${country}" not found`);
        return;
      }

      if (matchingStores.length > 1) {
        if (!duplicateStoreWarned.has(lookupKey)) {
          duplicateStoreWarned.add(lookupKey);
          duplicateWarnings.push(
            `Store ${storeNumber} in ${country} has ${matchingStores.length} entries in the system - skipping all rows for this store`
          );
        }
        return;
      }

      const store = matchingStores[0];
      const keyDef = allKeyDefinitions.find((def) => def.key === key);
      const normalizedValue = keyDef?.type === 'BOOLEAN' ? value.toLowerCase() : value;
      validRows.push({
        brand: store.brand || 'NIKE',
        country: store.address.country,
        geo: toGeo(store),
        key,
        storeName: store.name,
        storeNumber: store.storeNumber,
        value: normalizedValue,
      });
    });

    setCsvParsedData(validRows);
    setCsvErrors(errors);
    setCsvDuplicateWarnings(duplicateWarnings);
    setIsCsvPreviewModalOpen(true);
  };

  const downloadSampleCsv = () => {
    const sampleContent = [
      'storeNumber,country,key,value',
      '1234,USA,pos.receiptEnabled,true',
      '5678,GBR,pos.receiptEnabled,false',
      '9012,CHN,sco.maxItems,25',
      '3456,USA,sfs.pickupEnabled,true',
      '7890,JPN,pos.defaultLanguage,ja-JP',
      '2345,FRA,sco.maxItems,30',
    ].join('\n');
    const blob = new Blob([sampleContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'SCS_Bulk_Upload_Sample.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const downloadFailedConfigsCsv = () => {
    const header = 'key,scopeType,scope';
    const rows = failedConfigs.map((c) => `${c.key},${c.scopeType},${c.scope}`);
    const csvContent = [header, ...rows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'SCS_Failed_Configs.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleCsvFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.name.toLowerCase().endsWith('.csv')) {
      setCsvErrors(['Invalid file type. Please upload a .csv file']);
      setCsvParsedData([]);
      setCsvDuplicateWarnings([]);
      setIsCsvPreviewModalOpen(true);
      event.target.value = '';
      return;
    }

    if (file.size > MAX_CSV_FILE_SIZE) {
      setCsvErrors([`File size (${(file.size / (1024 * 1024)).toFixed(1)} MB) exceeds the maximum allowed size of 5 MB`]);
      setCsvParsedData([]);
      setCsvDuplicateWarnings([]);
      setIsCsvPreviewModalOpen(true);
      event.target.value = '';
      return;
    }

    setCsvFileName(file.name);
    const reader = new FileReader();
    reader.onload = (e) => {
      processCsvText(e.target.result);
      reader.onload = null;
      reader.onerror = null;
    };
    reader.onerror = () => {
      setCsvErrors(['Failed to read CSV file']);
      setCsvParsedData([]);
      setCsvDuplicateWarnings([]);
      setIsCsvPreviewModalOpen(true);
      reader.onload = null;
      reader.onerror = null;
    };
    reader.readAsText(file);
    event.target.value = '';
  };

  const submitCsvBulkUpdate = async () => {
    setIsCsvUploading(true);

    const grouped = {};
    csvParsedData.forEach((row) => {
      const groupKey = JSON.stringify([row.key, row.value]);
      if (!grouped[groupKey]) {
        grouped[groupKey] = {
          key: row.key,
          scopeInfo: [],
          scopeType: 'STORE',
          value: row.value,
        };
      }
      grouped[groupKey].scopeInfo.push({
        hierarchy: {
          brand: row.brand,
          country: row.country,
          geo: row.geo,
        },
        scope: `${row.country}-${row.storeNumber}`,
      });
    });

    const body = {
      changeRequest: {
        justification: generateJustification(Object.values(grouped)),
        requestedBy: userInfo?.email || '',
      },
      data: Object.values(grouped),
    };

    trackScsBulkEditExecuted({
      hasJustification: true,
      keysCount: Object.keys(grouped).length,
      region: selectedScsRegionOption?.value || 'use1',
      scopesCount: csvParsedData.length,
      scopeType: 'STORE',
      userEmail: userInfo?.email,
    });

    try {
      const scsRegion = selectedScsRegionOption?.value || 'use1';
      const response = await scsBulkedit(accessToken, body, scsRegion);
      setFailedConfigs(response.body.failure || []);
      setSuccessfulConfigs(response.body.success || []);

      trackScsBulkEditSuccess({
        failedCount: response.body.failure?.length || 0,
        successCount: response.body.success?.length || 0,
        totalCount: (response.body.success?.length || 0) + (response.body.failure?.length || 0),
        userEmail: userInfo?.email,
      });

      setIsCsvPreviewModalOpen(false);
      setIsBulkUpdateSuccessModalOpen(true);
      resetCsvState();
    } catch (error) {
      trackScsBulkEditError({
        errorMessage: error.message || 'Unknown error',
        keysCount: Object.keys(grouped).length,
        scopesCount: csvParsedData.length,
        userEmail: userInfo?.email,
      });
      setIsCsvPreviewModalOpen(false);
      setIsBulkUpdateFailureModalOpen(true);
      resetCsvState();
    } finally {
      setIsCsvUploading(false);
    }
  };

  const getBoxLabel = () => {
    if (selectedScsScopeOption?.value === 'STORE') {
      return 'Stores';
    } else if (selectedScsScopeOption?.value === 'COUNTRY') {
      return 'Countries';
    } else if (selectedScsScopeOption?.value === 'GEO') {
      return 'Geos';
    } else if (selectedScsScopeOption?.value === 'GLOBAL') {
      return 'Global';
    } else {
      return '';
    }
  };

  useEffect(() => {
    async function fetchData() {
      const fieldQuery = fields.join(',');
      try {
        const response = await getStores(fieldQuery);
        setStores(response);
      } catch (err) {
        console.error(err);
      }
    }
    fetchData();
  }, [accessToken]);

  useEffect(() => {
    const fetchAllKeyDefinitions = async () => {
      const selectedRegion = selectedScsRegionOption?.value || 'use1';
      const data = await scsDefinitionGet(accessToken, selectedRegion);
      const { objects: definitions } = data?.body;
      const scsGroups = scsKeyGroups.filter((group) => isUserAllowed(userInfo.groups, group));

      definitions.forEach((definition) => {
        definition.group = definition.group || 'Other Settings';
      });

      const filteredDefinitions = definitions.filter((definition) => scsGroups.includes('SCS.ALL') || scsGroups.includes(securityGroupMap.get(definition.group)));

      setAllKeyDefinitions(filteredDefinitions);
    };

    fetchAllKeyDefinitions();
  }, [selectedScsRegionOption, accessToken]);

  return (
    <main className="ncss-col-sm-12 parent-edit-class">
      {
        stores.length === 0 ? (
          <Loading />
        ) : (
          stores.length > 0 && (
            <article className="ncss-col-sm-12">
              <article className="ncss-col-sm-12">
                <article className="ncss-col-sm-12">
                  <article className="ncss-col-sm-12">
                    <article className="ncss-col-sm-12 pb2-sm">
                      <article className="ncss-col-sm-2 va-sm-b ta-sm-c"> </article>
                      <article className="ncss-col-sm-4 va-sm-b ta-sm-c">
                        AWS Region
                        <ReactSelect
                          classNamePrefix="react-select"
                          clearable={false}
                          id="scsRegion"
                          isDisabled={isEditMode}
                          options={config.scsRegionOptions}
                          placeholder="Select a Region"
                          styles={{
                      container: (styles) => ({ ...styles, zIndex: 100 }),
                      control: (styles) => ({
                        ...styles,
                        borderColor: 'lightgrey',
                        padding: '0px 0px 0px 3px',
                      }),
                    }}
                          value={selectedScsRegionOption}
                          onChange={(regionOption) => updateRegion(regionOption)}
                        />
                      </article>
                      <article className="ncss-col-sm-4 va-sm-b ta-sm-c">
                        Scope:
                        <ReactSelect
                          classNamePrefix="react-select"
                          clearable={false}
                          id="scsScopes"
                          isDisabled={isEditMode}
                          options={config.scsScopeOptions}
                          placeholder="Select a Scope"
                          styles={{
                      container: (styles) => ({ ...styles, zIndex: 100 }),
                      control: (styles) => ({
                        ...styles,
                        borderColor: 'lightgrey',
                        padding: '0px 0px 0px 3px',
                      }),
                    }}
                          value={selectedScsScopeOption}
                          onChange={(scopeOption) => updateScsScope(scopeOption)}
                        />
                      </article>
                      <article className="ncss-col-sm-2 va-sm-b ta-sm-r">
                        { selectedScsRegionOption && selectedScsScopeOption && selectedScsScopeOption.value === 'STORE' && !isEditMode && (
                          <ButtonBlack label="Filters" onClick={applyFilter} />
                        )}
                      </article>
                    </article>
                  </article>
                </article>
              </article>
              { !isEditMode && (
                <div className="show-filter-container">
                  {!isFilterEmpty() ? (<> Selected Filters: </>) : <></>}
                  {Object.entries(filteringCondition).map(([key, value]) => (
                  value.value !== '' && key !== 'regionSelected' && key !== 'search' ? (
                    <div key={key} className="bulk-chip">
                      {`${value.label}`}
                      <span className="bulk-close-icon"><Close name="Close" size="s" style={{ flexDirection: 'row', outline: 'none', verticalAlign: 'bottom' }} onClick={() => cancelFilter(key)} /></span>
                    </div>
                    ) : null
                    ))}
                </div>
              )}
              { !isEditMode && selectedScsRegionScopeOption && selectedScsRegionScopeOption.value !== 'GLOBAL' ? (
                <article className="ncss-col-sm-12 va-sm-t ta-sm-r">
                  <article className="ncss-col-sm-12 bulk-edit-article-height">
                    {selectedScsScopeOption
              && selectedScsRegionOption && (
                <article className="ncss-col-sm-12">
                  <br />
                  <article className="ncss-col-sm-12">
                    <section className="ncss-col-sm-6 va-sm-t ta-sm-c">
                      <label htmlFor="search">{`Available ${getBoxLabel()} - ${getSelectionList().length}`}</label>
                    </section>
                    <section className="ncss-col-sm-6 va-sm-t ta-sm-c">
                      <label htmlFor="search">{`Selected ${getBoxLabel()} - ${selectedCommonSelectorOption?.data.length || 0}`}</label>
                    </section>
                  </article>
                  { (selectedScsScopeOption.value === 'STORE' || selectedScsScopeOption.value === 'COUNTRY') && (
                  <article className="ncss-col-sm-12 pb2-sm">
                    <section className="ncss-col-sm-6 va-sm-t ta-sm-l">
                      <Input
                        label=""
                        placeholder={`Search available ${getBoxLabel()}`}
                        style={{ zIndex: 1 }}
                        type="text"
                        value={selectionSearch}
                        onChange={({ target: { value } }) => setSelectionSearch(value)}
                      />
                    </section>
                    <section className="ncss-col-sm-6 va-sm-t ta-sm-l">
                      <Input
                        label=""
                        placeholder={`Search selected ${getBoxLabel()}`}
                        style={{ zIndex: 1 }}
                        type="text"
                        value={selectedSearch}
                        onChange={({ target: { value } }) => setSelectedSearch(value)}
                      />
                    </section>
                  </article>
                  )}
                  <article className="ncss-col-sm-12">
                    <article className="ncss-col-sm-6 va-sm-t ta-sm-l">
                      <div className="key-list">
                        {
                        getSelectionList().map((selection) => (
                          <div
                            key={selection.id}
                            className={`key-item ${
                              selectedKey === selection.id ? 'selected' : ''
                            }`}
                            onClick={() => updateCommonSelector(selection)}
                          >
                            {selectedScsScopeOption.value === 'STORE'
                            ? `${selection.storeNumber} - ${selection.name} - ${selection.facilityType} - ${selection.company}`
                            : selection.name}
                          </div>
                        ))
                      }
                      </div>
                    </article>
                    <article className="ncss-col-sm-6 va-sm-t ta-sm-l">
                      <div className="key-list">
                        { selectedCommonSelectorOption && (
                        <Selected
                          input={selectedCommonSelectorOption}
                          search={selectedSearch}
                          onUpdate={updateSelectedCommonSelectorOption}
                        />
                        )}
                      </div>
                    </article>
                  </article>
                </article>
              )}
                  </article>
                  { selectedScsRegionOption && selectedScsScopeOption && (
                  <article className="ncss-col-sm-12">
                    <ButtonBlack
                      isDisabled={selectedCommonSelectorOption === null}
                      label="Next"
                      onClick={() => {
                        // Track bulk edit started (entering edit mode)
                        trackScsBulkEditStarted({
                          region: selectedScsRegionOption?.value,
                          scopeType: selectedScsScopeOption?.value,
                          selectedCount: selectedCommonSelectorOption?.data?.length || 0,
                          userEmail: userInfo?.email,
                        });
                        setIsEditMode(true);
                      }}
                    />
                  </article>
              )}
                </article>
          ) : (
            <>
              <article className={selectedScsScopeOption?.value === 'GLOBAL' ? 'ncss-col-sm-12 va-sm-t ta-sm-c' : 'ncss-col-sm-12 va-sm-t ta-sm-r'}>
                <article className="ncss-col-sm-12 bulk-edit-article-height">
                  {selectedScsScopeOption
              && selectedScsRegionOption && (
                <article className="ncss-col-sm-12">
                  <br />
                  <article className="ncss-col-sm-12 pb2-sm">
                    { selectedScsScopeOption && selectedScsScopeOption.value !== 'GLOBAL' && (
                    <section className="ncss-col-sm-6 va-sm-t ta-sm-l">
                      <label className="ncss-col-sm-12 va-sm-t ta-sm-c" htmlFor="search">{`Selected ${getBoxLabel() } - ${selectedCommonSelectorOption?.data.length || 0}`}</label>
                      <Input
                        label=""
                        placeholder={`Search selected ${getBoxLabel()}`}
                        style={{ zIndex: 1 }}
                        type="text"
                        value={selectedSearch}
                        onChange={({ target: { value } }) => setSelectedSearch(value)}
                      />
                    </section>
                    )}
                    <section className={selectedScsScopeOption.value === 'GLOBAL' ? 'ncss-col-sm-8 va-sm-t ta-sm-c' : 'ncss-col-sm-6 va-sm-t ta-sm-l'}>
                      <label className="ncss-col-sm-12 va-sm-t ta-sm-c" htmlFor="search">{`Selected Config Keys - ${selectedKeys.length}`}</label>
                      <ReactSelect
                        classNamePrefix="react-select"
                        id="scsKey"
                        inputValue={inputValue}
                        isDisabled={false}
                        noOptionsMessage={() => (inputValue.length < 3 ? 'Type at least 3 characters' : 'No options')}
                        options={filterScsKeyOptionsForRegion}
                        placeholder="Search for Config Key"
                        styles={{
            container: (containerStyles) => ({ ...containerStyles, zIndex: 10 }),
            control: (controlStyles) => ({
              ...controlStyles,
              borderColor: 'lightgrey',
              fontSize: '14px',
              padding: '0px 0px 0px 3px',
            }),
          }}
                        value={selectedKey}
                        onChange={(keyOption) => updateScsKey(keyOption)}
                        onInputChange={handleInputChange}
                        onMenuOpen={handleMenuOpen}
                      />
                    </section>
                  </article>
                  <article className="ncss-col-sm-12">
                    { selectedScsScopeOption && selectedScsScopeOption.value !== 'GLOBAL' && (
                    <article className={selectedScsScopeOption.value === 'GLOBAL' ? 'ncss-col-sm-8 va-sm-t ta-sm-l' : 'ncss-col-sm-6 va-sm-t ta-sm-l'}>
                      <div className="key-list">
                        { selectedCommonSelectorOption && (
                        <Selected
                          input={selectedCommonSelectorOption}
                          search={selectedSearch}
                          update={false}
                          onUpdate={updateSelectedCommonSelectorOption}
                        />
                        )}
                      </div>
                    </article>
                  )}
                    <article className={selectedScsScopeOption.value === 'GLOBAL' ? 'ncss-col-sm-8 va-sm-t ta-sm-l' : 'ncss-col-sm-6 va-sm-t ta-sm-l'}>
                      {/* Centered Outer Box */}
                      <div className="key-list">
                        {
                          selectedKeys.map((key, index) => (
                            <div key={key.label} className="edit-key-item">
                              <article className="ncss-col-sm-12">
                                <div className="d-sm-flx flx-ai-sm-c">
                                  <article className="ncss-col-sm-5 va-sm-c">
                                    <span className="edit-key-item key-name headline-5">{key.label}</span>
                                  </article>
                                  <article className="ncss-col-sm-6 va-sm-t ta-sm-l">
                                    {key.type === 'STRING' && (
                                    <Input
                                      className="value-input"
                                      placeholder="String Value"
                                      type="text"
                                      value={key.value}
                                      onChange={(e) => handleValueChange(index, e.target.value)}
                                    />
                              )}
                                    {key.type === 'INTEGER' && (
                                    <Input
                                      className="value-input"
                                      placeholder="Integer Value"
                                      type="number"
                                      value={key.value}
                                      onChange={(e) => handleValueChange(index, e.target.value)}
                                    />
                              )}
                                    {key.type === 'BOOLEAN' && (
                                    <ReactSelect
                                      classNamePrefix="react-select"
                                      clearable={false}
                                      id="scsRegion"
                                      options={['true', 'false'].map((value) => ({ label: value, value }))}
                                      placeholder="Boolean Value"
                                      styles={{
                                        container: (styles) => ({ ...styles }),
                                        control: (styles) => ({
                                          ...styles,
                                          borderColor: 'lightgrey',
                                          fontSize: '14px',
                                          padding: '0px 0px 0px 3px',
                                        }),
                                      }}
                                      value={key.value ? { label: key.value, value: key.value } : null}
                                      onChange={(e) => handleValueChange(index, e.value)}
                                    />
                              )}
                                  </article>
                                  <article className="ncss-col-sm-1 va-sm-c ta-sm-c">
                                    <Delete name="Delete" size="m" onClick={() => removeKey(index)} />
                                  </article>
                                </div>
                              </article>
                            </div>
                          ))
                        }
                      </div>
                    </article>
                  </article>
                </article>
              )}
                </article>
                { selectedScsRegionOption && selectedScsScopeOption && (
                  <article className="ncss-col-sm-12 mt2-sm">
                    <article className="ncss-col-sm-12">
                      <article className="ncss-col-sm-12">
                        <ScheduleForLater
                          id="bulkScheduleForLaterToggle"
                          scheduleForLater={scheduleForLater}
                          scheduledDate={scheduledDate}
                          scheduledTime={scheduledTime}
                          onDateChange={setScheduledDate}
                          onTimeChange={setScheduledTime}
                          onToggle={setScheduleForLater}
                        />
                      </article>
                    </article>
                    <article className="ncss-col-sm-12" style={{ marginTop: '12px' }}>
                      { selectedScsScopeOption.value !== 'GLOBAL' && (
                      <ButtonBlack
                        isDisabled={selectedCommonSelectorOption === null}
                        label="Previous"
                        onClick={() => { setIsEditMode(false); resetScheduleState(); }}
                      />
                      )}
                      { isBulkUpdateComplete && isScheduleComplete ? (
                        <ButtonBlack
                          isDisabled={selectedKeys.length === 0 || (scheduleForLater && (!scheduledDate || !scheduledTime))}
                          label={scheduleForLater ? 'Schedule' : 'Update'}
                          onClick={() => { setIsUpdateConfirmModalOpen(true); }}
                        />
                      ) : (
                        <ButtonBlack
                          isDisabled
                          label="Loading..."
                          onClick={() => {}}
                        />
                      )}
                    </article>
                  </article>
              )}
              </article>
            </>
          ) }
            </article>
          )
        )
      }
      <div>
        <FilterOverlay
          clearAllFilters={clearAllFilters}
          filterApplied={filterApplied}
          filteringCondition={filteringCondition}
          isFilterOverlayVisible={isFilterOverlayVisible}
          stores={stores}
          updateFilterRef={updateFilterRef}
          onClose={closeFilterOverlay}
          onFilterUpdate={updateStores}
          onFilteringConditionChange={handleFilteringConditionChange}
        />
      </div>

      { selectedScsRegionOption && selectedScsScopeOption && selectedScsScopeOption.value === 'STORE' && !isEditMode && (
        <section className="ncss-row pb6-sm va-sm-t">
          <article className="ncss-col-lg-3 ncss-col-sm-12">
            <h1 className="text-color-accent body-1 mt2-sm mb-2-sm">CSV Bulk Upload</h1>
            <ButtonBlack
              className="mt3-sm"
              label="Download Template CSV"
              onClick={downloadSampleCsv}
            />
          </article>
          <article className="ncss-col-lg-3 ncss-col-sm-9 va-sm-t mt3-sm">
            <Input
              key={csvFileComponentKey}
              accept=".csv"
              datatype="text"
              id="csvFileInput"
              label="File Upload"
              type="file"
              onChange={handleCsvFileSelect}
            />
          </article>
          <article className="ncss-col-lg-2 ncss-col-sm-3 va-sm-t">
            <ButtonWhite
              label="Clear"
              onClick={resetCsvState}
            />
          </article>
        </section>
      )}

      <Modal
        buttonName="OK"
        isOpen={isBulkUpdateSuccessModalOpen}
        title=""
        onClose={() => handleModalClose()}
      >
        {
          failedConfigs.length === 0 ? (
            <p>{`All ${successfulConfigs.length} config(s) ${wasScheduled ? 'scheduled' : 'updated'} successfully!`}</p>
          ) : (
            <>
              {successfulConfigs.length === 0
                ? (<p>{`Bulk ${wasScheduled ? 'Schedule' : 'Update'} Failed!!`}</p>)
                : (<p>{`Partial Success: ${successfulConfigs.length} out of ${successfulConfigs.length + failedConfigs.length} config(s) ${wasScheduled ? 'scheduled' : 'updated'} successfully.`}</p>)}
              <p>{`${failedConfigs.length} config(s) failed:`}</p>
              <TableRowClick
                showPagination
                columns={columns}
                data={failedConfigs}
                defaultPageSize={failedConfigs.length % 10 === 0 ? 10 : failedConfigs.length % 10}
              />
              <div className="bulk-edit-actions-row">
                <ButtonWhite
                  className="border"
                  label="Download Failed Configs"
                  onClick={downloadFailedConfigsCsv}
                />
                <ButtonBlack
                  className=""
                  label="OK"
                  onClick={() => handleModalClose()}
                />
              </div>
            </>
          )
        }
      </Modal>

      <Modal
        buttonName="OK"
        isOpen={isBulkUpdateFailureModalOpen}
        title=""
        onClose={() => handleModalClose()}
      >
        <p>{`Bulk ${wasScheduled ? 'Schedule' : 'Update'} Failed!!`}</p>
      </Modal>

      <Modal
        buttonName="Cancel"
        isOpen={isRegionChangeModalOpen}
        title="Confirm Region Change"
        onClose={() => setIsRegionChangeModalOpen(false)}
      >
        <p>Are you sure you want to change region?</p>
        <p>{`Note: Switching region will lead to clearing of selected ${getBoxLabel()}`}</p>
        <ButtonRed confirm={false} label="Confirm" onClick={changeRegion} />
      </Modal>

      <Modal
        buttonName="Cancel"
        isOpen={isScopeChangeModalOpen}
        title="Confirm Scope Change"
        onClose={() => setIsScopeChangeModalOpen(false)}
      >
        <p>Are you sure you want to change scope?</p>
        <p>{`Note: Switching scope will lead to clearing of selected ${getBoxLabel()}`}</p>
        <ButtonRed confirm={false} label="Confirm" onClick={changeScope} />
      </Modal>

      <Modal
        buttonName="Cancel"
        isOpen={isUpdateConfirmModalOpen}
        title={scheduleForLater ? 'Confirm Scheduled Bulk Update' : 'Confirm Bulk Update'}
        onClose={() => setIsUpdateConfirmModalOpen(false)}
      >
        <p>{scheduleForLater
          ? 'Are you sure you want to schedule this bulk update?'
          : 'Are you sure you want to proceed with the bulk update?'}
        </p>
        <p>{`This will ${scheduleForLater ? 'schedule' : 'update'} ${selectedKeys.length} config key(s) across ${selectedCommonSelectorOption?.data?.length || 1} ${getBoxLabel() || 'scope(s)'}.`}</p>
        {scheduleForLater && scheduledDate && scheduledTime && (
          <div style={{ marginBottom: '12px', marginTop: '12px' }}>
            <ScheduleBanner
              scheduledDate={scheduledDate}
              scheduledTime={scheduledTime}
              variant="confirmation"
            />
          </div>
        )}
        {scheduleForLater && (
          <p style={{ fontSize: '13px', fontStyle: 'italic', marginTop: '8px' }}>
            <span style={{ fontWeight: 'bold' }}>Note:</span> This change will NOT apply immediately. It will be queued and applied automatically at the scheduled time.
          </p>
        )}
        <ButtonRed
          confirm={false}
          label="Confirm"
          onClick={() => {
            setIsUpdateConfirmModalOpen(false);
            if (scheduleForLater) {
              setWasScheduled(true);
              scheduleBulkConfigs();
            } else {
              setWasScheduled(false);
              updateBulkConfigs();
            }
          }}
        />
      </Modal>

      {isCsvPreviewModalOpen && (
        <div className="csv-modal-overlay">
          <div className="csv-modal-content">
            <h2 className="headline-2">{`CSV Upload Preview${csvFileName ? ` - ${csvFileName}` : ''}`}</h2>
            {csvErrors.length > 0 && (
              <div className="csv-error-box">
                <p><strong>Errors ({csvErrors.length}):</strong></p>
                <ul>
                  {/* eslint-disable-next-line react/no-array-index-key */}
                  {csvErrors.map((err, idx) => <li key={idx}>{err}</li>)}
                </ul>
              </div>
            )}
            {csvDuplicateWarnings.length > 0 && (
              <div className="csv-warning-box">
                <p><strong>Skipped - Conflicting Values ({csvDuplicateWarnings.length}):</strong></p>
                <ul>
                  {/* eslint-disable-next-line react/no-array-index-key */}
                  {csvDuplicateWarnings.map((w, idx) => <li key={idx}>{w}</li>)}
                </ul>
              </div>
            )}
            {csvParsedData.length > 0 ? (
              <>
                <p className="mt2-sm mb2-sm">
                  <strong>{csvParsedData.length}</strong> valid store config(s) will be updated.
                </p>
                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  <TableRowClick
                    showPagination
                    columns={csvPreviewColumns}
                    data={csvParsedData}
                    defaultPageSize={10}
                  />
                </div>
              </>
            ) : (
              csvErrors.length === 0 && csvDuplicateWarnings.length === 0 && (
                <p>No valid entries found in the CSV file.</p>
              )
            )}
            <div className="csv-modal-actions">
              {csvParsedData.length > 0 && (
                <ButtonBlack
                  className=""
                  isDisabled={isCsvUploading}
                  label={isCsvUploading ? 'Uploading...' : 'Confirm Upload'}
                  onClick={submitCsvBulkUpdate}
                />
              )}
              <ButtonBlack
                className=""
                label="Cancel"
                onClick={() => {
                  resetCsvState();
                  setIsCsvPreviewModalOpen(false);
                }}
              />
            </div>
          </div>
        </div>
      )}

    </main>
  );
};

export default SCSBulkEdit;
